export default "__VITE_ASSET__CJiY45mE__"